import React, { useEffect, useState } from 'react';
import './HeroCarousel.css';

const SLIDES = [
  { src: '/index/banner1.png', alt: 'Faynet - Internet residencial, mais conexão para a sua casa' },
  { src: '/index/banner2.png', alt: 'Faynet - Planos e ofertas de internet' },
];

const MOBILE_BANNER = {
  src: '/index/banner-index-mobile.png',
  alt: 'Faynet - Internet residencial com destaque para planos e beneficios no mobile',
};

const MOBILE_SLIDES = [
  {
    src: '/index/banner-index-mobile.png',
    alt: 'Faynet - Internet residencial com destaque para planos e beneficios no mobile',
    type: 'plans',
  },
  {
    src: '/index/banner-index-mobile2.png',
    alt: 'Faynet - acompanhe nossas novidades nas redes sociais',
    type: 'social',
  },
];

const FACEBOOK_URL = 'https://www.facebook.com/faynetrj';
const INSTAGRAM_URL = 'https://www.instagram.com/faynet_rj';

const AUTOPLAY_MS = 6000;

function HeroCarousel() {
  const [desktopCurrent, setDesktopCurrent] = useState(0);
  const [mobileCurrent, setMobileCurrent] = useState(0);

  const goToPrevMobile = () => {
    setMobileCurrent((prev) => (prev - 1 + MOBILE_SLIDES.length) % MOBILE_SLIDES.length);
  };

  const goToNextMobile = () => {
    setMobileCurrent((prev) => (prev + 1) % MOBILE_SLIDES.length);
  };

  const scrollToPlans = () => {
    document.getElementById('home-planos')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setDesktopCurrent((prev) => (prev + 1) % SLIDES.length);
    }, AUTOPLAY_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="hero-carousel">
      <div className="hero-carousel__desktop" aria-hidden="false">
        {SLIDES.map((slide, index) => (
          <img
            key={slide.src}
            src={slide.src}
            alt={slide.alt}
            className={`hero-carousel__slide ${index === desktopCurrent ? 'hero-carousel__slide--active' : ''}`}
          />
        ))}

        <div className="hero-carousel__dots">
          {SLIDES.map((slide, index) => (
            <button
              key={slide.src}
              type="button"
              className={`hero-carousel__dot ${index === desktopCurrent ? 'hero-carousel__dot--active' : ''}`}
              onClick={() => setDesktopCurrent(index)}
              aria-label={`Ir para o slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      <div className="hero-carousel__mobile-frame">
        <button
          type="button"
          className="hero-carousel__mobile-arrow hero-carousel__mobile-arrow--prev"
          onClick={goToPrevMobile}
          aria-label="Ver banner mobile anterior"
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M15 18 9 12l6-6" />
          </svg>
        </button>

        <div className="hero-carousel__mobile-mask">
          <div
            className="hero-carousel__mobile-track"
            style={{ transform: `translateX(-${mobileCurrent * 100}%)` }}
          >
            {MOBILE_SLIDES.map((slide) => (
              <div key={slide.src} className="hero-carousel__mobile-slide">
                <img
                  src={slide.src}
                  alt={slide.alt}
                  className="hero-carousel__mobile-banner"
                />

                {slide.type === 'plans' ? (
                  <button
                    type="button"
                    className="hero-carousel__mobile-cta hero-carousel__mobile-cta--plans"
                    onClick={scrollToPlans}
                  >
                    Conheca nossos planos
                  </button>
                ) : (
                  <div className="hero-carousel__mobile-socials">
                    <a
                      href={FACEBOOK_URL}
                      target="_blank"
                      rel="noreferrer"
                      className="hero-carousel__mobile-social-btn"
                    >
                      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true">
                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                      </svg>
                      <span>Abrir Facebook</span>
                    </a>

                    <a
                      href={INSTAGRAM_URL}
                      target="_blank"
                      rel="noreferrer"
                      className="hero-carousel__mobile-social-btn"
                    >
                      <svg viewBox="0 0 24 24" fill="none" width="16" height="16" aria-hidden="true">
                        <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="2" />
                        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
                        <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" />
                      </svg>
                      <span>Abrir Instagram</span>
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <button
          type="button"
          className="hero-carousel__mobile-arrow hero-carousel__mobile-arrow--next"
          onClick={goToNextMobile}
          aria-label="Ver proximo banner mobile"
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default HeroCarousel;
